<script>
  import { getContext } from "svelte"
  import PageTitle from "../parts/PageTitle.svelte";
  import { useProject } from "../../hooks/useProject.js";
  import GeneralInfoSection from "./sections/GeneralInfoSection.svelte";
  import ScheduledExecutionSection from "./sections/ScheduledExecutionSection.svelte";
  import AsprovaSettingsSection from "./sections/AsprovaSettingsSection.svelte";
  import DemoSettingsSection from "./sections/DemoSettingsSection.svelte";
  import DebugSection from "./sections/DebugSection.svelte";

  export let projectId

  const {handleFetchErrors} = getContext("fetchErrorHandler")

  const project = useProject(projectId, handleFetchErrors)
</script>

<div class="content-root">
  <PageTitle>プロジェクトの設定</PageTitle>
  {#if $project}
    <GeneralInfoSection project={$project} />
    <AsprovaSettingsSection />
    <ScheduledExecutionSection />
    <DemoSettingsSection />
    <DebugSection />
  {/if}
</div>

<style>
  .content-root {
    height: 100%;
    background-color: white;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
</style>
